import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function ComingSoon() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products", { params: { coming_soon: true, limit: 60 } }).then((r) => setProducts(r.data)); }, []);
  return (
    <div className="max-w-[1600px] mx-auto px-4 sm:px-8 py-10">
      <h1 className="display text-5xl md:text-7xl mb-8">COMING SOON</h1>
      {products.length === 0 ? <div className="text-neutral-500">Belum ada produk mendatang.</div> : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-8">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
